import { PropsWithChildren } from 'react';

import styles from './ProjectsSection.module.scss';
import ProjectsGrid from '../ProjectsGrid/ProjectsGrid';
import { Skeleton } from '@tcc-online/common-components';
import { css } from '@emotion/css';

type ProjectsSectionProps = PropsWithChildren<{
    name?: string;
    isLoading?: boolean;
}>;

export default function ProjectsSection(props: ProjectsSectionProps) {
    const { name, children, isLoading } = props;

    return (
        <div className={styles.section}>
            <h5>{name}</h5>
            <ProjectsGrid>
                {isLoading
                    ? Array.from(new Array(8), (_, i) => (
                          <Skeleton
                              key={i}
                              height={200}
                              className={css({ borderRadius: 8 })}
                          />
                      ))
                    : children}
            </ProjectsGrid>
        </div>
    );
}
